// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function (val,idNames) {
      if(idNames.length > 0){
        let title = val
        window.scrollTo(0,0);

        let temp = function(idName){
          return new Promise((resolve, reject) => {
            html2Canvas(document.querySelector('#'+idName),{
              allowTaint: true,
              scale: 3,
              logging: false
            }).then((canvas)=>{
              resolve(canvas.toDataURL('image/jpeg', 1.0));
            })
          })
        };
        let promiseArray = [];
        idNames.forEach((item)=>{
          promiseArray.push(temp(item));
        })
        Promise.all(promiseArray).then((result)=>{
          let pdf = new JsPDF('', 'pt', 'a4') // 下载尺寸 a4 纸 比例
          //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          //当内容未超过pdf一页显示的范围，无需分页
          result.forEach((item,index)=>{
            let obj = document.querySelector('#'+idNames[0]);
            let contentWidth = obj.clientWidth // 获得该容器的宽
            let contentHeight = obj.clientHeight // 获得该容器的高
            let imgWidth = 555.28
            let imgHeight = (imgWidth / contentWidth) * contentHeight
            pdf.addImage(item, 'JPEG', 20, 0, imgWidth, imgHeight)
            //避免添加空白页
            if (index < idNames.length-1) {
              pdf.addPage()
            }
          })

          pdf.save(title + '.pdf')
        })
      }

    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/html2Pdf.js
// module id = null
// module chunks = 